// ABOUTME: Minimal accessible button wrapper for CountryConfigurations interactive items.
// ABOUTME: Provides focus-visible ring and optional trailing icon via icon prop.
import {clx, Icon} from '@hm/fundamental'
import React from 'react'

interface CountryConfigurationsButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  icon?: string
}

export const CountryConfigurationsButton = ({className, children, icon, ...props}: CountryConfigurationsButtonProps) => (
  <button
    type="button"
    className={clx(
      'text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
      className
    )}
    {...props}
  >
    {children}
    {icon && <Icon path={icon} size="regular" color="var(--primary)" className="shrink-0" />}
  </button>
)
